import store from "@/plugins/store"

export default new class StoreRegister {
    handle(name, stores) {
        store.registerModule(name, stores)
    }
}
